module.exports = __webpack_public_path__ + "img/banner-nonfinancial.12656549.jpg";